import SiteMsgConfig from './SiteMsgConfig';
export default SiteMsgConfig;
